import { render, staticRenderFns } from "./WidgetMissionStatement.vue?vue&type=template&id=25543345&"
import script from "./WidgetMissionStatement.vue?vue&type=script&lang=js&"
export * from "./WidgetMissionStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports